import { Component, OnInit, OnDestroy, Input,Output,EventEmitter,HostListener } from '@angular/core';

@Component({
  selector: 'app-chart',
   templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit, OnDestroy {
  @Output()  onCloseChartToParent = new EventEmitter<any>();
  @Input() ChartData:any[];
  @Input() subTitle;
  @Input() universalAuditID;
  @Input() component;

  public AmadeusChartData:Array<{category:string, value:number}> =[];
  public ApolloChartData:Array<{category:string, value:number}> =[];
  public GalileoChartData:Array<{category:string, value:number}> =[];
  public SabreChartData:Array<{category:string, value:number}> =[];
  public WorldspanChartData:Array<{category:string, value:number}> =[];
  public HotelsNotInProgramChartData:Array<{category:string, value:number}> = [];
  public isAmadeusData:boolean;
  public isGalileoData:boolean;
  public isSabreData:boolean;
  public isWorldspanData:boolean;
  public isApolloData:boolean;

  public chartColor1='#0099E0';
  public chartColor2='#006D96';
  public chartColor3='#5F7D8C';
  public chartColor4='#1DAA42';
  public chartColor5='#EBA912';

  public height:number=0;
  public position:number=2;
  public legend:Array<{name:string, bgcolor:string}> =[];

  //public scrollTop:number;

  constructor() {
  }

  seriesColor=[this.chartColor1,this.chartColor2,this.chartColor3,this.chartColor4,this.chartColor5];

  public onPrimaryButtonClick() {
    this.onCloseChartToParent.emit();
  }

  public onCloseClick($event){
    this.onCloseChartToParent.emit();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event){
    this.height=this.getDocHeight();
  }

  public captureBodyClickEvent(event) {
    var t:HTMLElement = event.target;
    var cancelClose = false;
    while(t.parentElement!=null && t.parentElement.tagName!='BODY') {
      //do not close if the target is child of the app-chart, or the target
      //is the report icon

      //for some weird reason, className isn't a string for some elements
      if(t.parentElement.tagName=='APP-CHART' || (t.className && t.className.indexOf && t.className.indexOf('cvt-icon-reports')>-1)) {
        cancelClose = true;
        break;
      }
      t = t.parentElement;
      
    }
    if(!cancelClose && (<any>window).closeRateAvailabilityChartEmitter) {
      (<any>window).closeRateAvailabilityChartEmitter.emit();
    }
  }

  ngOnInit() {
    var body = document.getElementsByTagName('body')[0];
    body.addEventListener('click', this.captureBodyClickEvent, false);
    //need to put onCloseChartToParent in window variable
    //so captureBodyClickEvent function can call it
    (<any>window).closeRateAvailabilityChartEmitter = this.onCloseChartToParent;
    window.scrollTo(0, 0);
    this.position=2;
    this.height=this.getDocHeight();
    var titlebarHeight = document.getElementById('titleBar').offsetHeight;
    var legendHeight = document.getElementById('legendDiv').offsetHeight;
    document.getElementById('chartingDiv').style.height = (this.height - titlebarHeight - legendHeight- 50) + 'px';
    var d=document.getElementById('legendDiv')
    d.scrollTop=0;

    if(this.component=="RA") {
      this.legend.push({name:"Loaded",bgcolor:this.chartColor1})
      this.legend.push({name:"Not Loaded",bgcolor:this.chartColor2})
      this.legend.push({name:"Discrepancy",bgcolor:this.chartColor3})
    } else if(this.component=="RV") {
      this.legend.push({name:"Available",bgcolor:this.chartColor1})
      this.legend.push({name:"Available Higher",bgcolor:this.chartColor2})
      this.legend.push({name:"Available Lower",bgcolor:this.chartColor3})
      this.legend.push({name:"Rate Not Available",bgcolor:this.chartColor4})
      this.legend.push({name:"Hotel Not Available",bgcolor:this.chartColor5})
    } else if(this.component=='RVRS') {
      this.legend.push({name:"Amadeus",bgcolor:this.chartColor1});
      this.legend.push({name:"Apollo",bgcolor:this.chartColor2});
      this.legend.push({name:"Galileo",bgcolor:this.chartColor3});
      this.legend.push({name:"Sabre",bgcolor:this.chartColor4});
      this.legend.push({name:"Worldspan",bgcolor:this.chartColor5});
    }
  }

  ngOnDestroy() {
    var body = document.getElementsByTagName('body')[0];
    body.removeEventListener('click', this.captureBodyClickEvent, false);
  }

  getDocHeight() {
    var D = document;
    D.body.scrollTop=0;

    return Math.max(
        Math.max(D.body.scrollHeight, D.documentElement.scrollHeight),
        Math.max(D.body.offsetHeight, D.documentElement.offsetHeight),
        Math.max(D.body.clientHeight, D.documentElement.clientHeight)
    );
  }

  ngOnChanges() {
    window.scrollTo(0, 0)
    this.AmadeusChartData=[];
    this.ApolloChartData=[];
    this.GalileoChartData=[];
    this.SabreChartData=[];
    this.WorldspanChartData=[];
    this.HotelsNotInProgramChartData=[];
    this.isAmadeusData=false;
    this.isGalileoData=false;
    this.isApolloData=false;
    this.isSabreData=false;
    this.isWorldspanData=false;
    var d=document.getElementById('sidebar')
    d.scrollTop=0;
    if(this.ChartData) {
      if(this.component=="RA") {
        if(this.ChartData["AuditAmadeus"]==true){
          this.isAmadeusData=true;

          this.AmadeusChartData.push({category:"Loaded",value:this.ChartData["AmadeusLoaded"]});
          this.AmadeusChartData.push({category:"Not Loaded",value:this.ChartData["AmadeusNotLoaded"]});
          this.AmadeusChartData.push({category:"Discrepency",value:this.ChartData["AmadeusDiscrepancy"]});
        } else {
          this.isAmadeusData=false;
        }
        if(this.ChartData["AuditApollo"]==true) {
          this.isApolloData=true;

          this.ApolloChartData.push({category:"Loaded",value:this.ChartData["ApolloLoaded"]});
          this.ApolloChartData.push({category:"Not Loaded",value:this.ChartData["ApolloNotLoaded"]});
          this.ApolloChartData.push({category:"Discrepency",value:this.ChartData["ApolloDiscrepancy"]});
        } else {this.isApolloData=false;}
        if(this.ChartData["AuditGalileo"]==true) {
          this.isGalileoData=true;

          this.GalileoChartData.push({category:"Loaded",value:this.ChartData["GalileoLoaded"]});
          this.GalileoChartData.push({category:"Not Loaded",value:this.ChartData["GalileoNotLoaded"]});
          this.GalileoChartData.push({category:"Discrepency",value:this.ChartData["GalileoDiscrepancy"]});
        }
        if(this.ChartData["AuditSabre"]==true) {
          this.isSabreData=true;

          this.SabreChartData.push({category:"Loaded",value:this.ChartData["SabreLoaded"]});
          this.SabreChartData.push({category:"Not Loaded",value:this.ChartData["SabreNotLoaded"]});
          this.SabreChartData.push({category:"Discrepency",value:this.ChartData["SabreDiscrepancy"]});
        } else{this.isSabreData=false;}
        if(this.ChartData["AuditWorldspan"]==true) {
          this.isWorldspanData=true;

          this.WorldspanChartData.push({category:"Loaded",value:this.ChartData["WorldspanLoaded"]});
          this.WorldspanChartData.push({category:"Not Loaded",value:this.ChartData["WorldspanNotLoaded"]});
          this.WorldspanChartData.push({category:"Discrepency",value:this.ChartData["WorldspanDiscrepancy"]});
        }
        else {
          this.isWorldspanData=false;
        }
      } else if(this.component=="RV") {
        if(this.ChartData["AuditAmadeus"]==true) {
          this.isAmadeusData=true;

          this.AmadeusChartData.push({category:"Available",value:this.ChartData["AmadeusAvailable"]});
          this.AmadeusChartData.push({category:"Available Higher",value:this.ChartData["AmadeusLoadedHigher"]});
          this.AmadeusChartData.push({category:"Available Lower",value:this.ChartData["AmadeusLoadedLower"]});
          this.AmadeusChartData.push({category:"Rate Not Available",value:this.ChartData["AmadeusNotAvailable"]});
          this.AmadeusChartData.push({category:"Hotel Not Available",value:this.ChartData["AmadeusHNA"]});
        } else {
          this.isAmadeusData=false;
        }
        if(this.ChartData["AuditApollo"]==true) {
          this.isApolloData=true;

          this.ApolloChartData.push({category:"Available",value:this.ChartData["ApolloAvailable"]});
          this.ApolloChartData.push({category:"Available Higher",value:this.ChartData["ApolloLoadedHigher"]});
          this.ApolloChartData.push({category:"Available Lower",value:this.ChartData["ApolloLoadedLower"]});
          this.ApolloChartData.push({category:"Rate Not Available",value:this.ChartData["ApolloNotAvailable"]});
          this.ApolloChartData.push({category:"Hotel Not Available",value:this.ChartData["ApolloHNA"]});
        } else {
          this.isApolloData=false;
        }
        if(this.ChartData["AuditGalilo"]==true) {
          //AuditGalilo is not a mistake thats the spelling that is being returned from the service
          this.isGalileoData=true;

          this.GalileoChartData.push({category:"Available",value:this.ChartData["GalileoAvailable"]});
          this.GalileoChartData.push({category:"Available Higher",value:this.ChartData["GalileoLoadedHigher"]});
          this.GalileoChartData.push({category:"Available Lower",value:this.ChartData["GalileoLoadedLower"]});
          this.GalileoChartData.push({category:"Rate Not Available",value:this.ChartData["GalileoNotAvailable"]});
          this.GalileoChartData.push({category:"Hotel Not Available",value:this.ChartData["GalileoHNA"]});
        }
        if(this.ChartData["AuditSabre"]==true) {
          this.isSabreData=true;

          this.SabreChartData.push({category:"Available",value:this.ChartData["SabreAvailable"]});
          this.SabreChartData.push({category:"Available Higher",value:this.ChartData["SabreLoadedHigher"]});
          this.SabreChartData.push({category:"Available Lower",value:this.ChartData["SabreLoadedLower"]});
          this.SabreChartData.push({category:"Rate Not Available",value:this.ChartData["SabreNotAvailable"]});
          this.SabreChartData.push({category:"Hotel Not Available",value:this.ChartData["SabreHNA"]});
        } else {
          this.isSabreData=false;
        }
        if(this.ChartData["AuditWorldspan"]==true) {
          this.isWorldspanData=true;

          this.WorldspanChartData.push({category:"Available",value:this.ChartData["WorldspanAvailable"]});
          this.WorldspanChartData.push({category:"Available Higher",value:this.ChartData["WorldspanLoadedHigher"]});
          this.WorldspanChartData.push({category:"Available Lower",value:this.ChartData["WorldspanLoadedLower"]});
          this.WorldspanChartData.push({category:"Rate Not Available",value:this.ChartData["WorldspanNotAvailable"]});
          this.WorldspanChartData.push({category:"Hotel Not Available",value:this.ChartData["WorldspanHNA"]});
        } else {
          this.isWorldspanData=false;
        }
      } else if(this.component=='RVRS') {
        this.seriesColor=[];
        if(this.ChartData['AuditAmadeus']) {
          this.HotelsNotInProgramChartData.push({category:'Amadeus',value:this.ChartData['AmadeusOutOfProgram']});
          this.seriesColor.push(this.chartColor1);
        }
        if(this.ChartData['AuditApollo']) {
          this.HotelsNotInProgramChartData.push({category:'Apollo',value:this.ChartData['ApolloOutOfProgram']});
          this.seriesColor.push(this.chartColor2);
        }
        if(this.ChartData['AuditGalileo']) {
          this.HotelsNotInProgramChartData.push({category:'Galileo',value:this.ChartData['GalileoOutOfProgram']});
          this.seriesColor.push(this.chartColor3);
        }
        if(this.ChartData['AuditSabre']) {
          this.HotelsNotInProgramChartData.push({category:'Sabre',value:this.ChartData['SabreOutOfProgram']});
          this.seriesColor.push(this.chartColor4);
        }
        if(this.ChartData['AuditWorldspan']) {
          this.HotelsNotInProgramChartData.push({category:'Worldspan',value:this.ChartData['WorldspanOutOfProgram']});
          this.seriesColor.push(this.chartColor5);
        }
      }
    }
  }
}
